import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { Toaster, toast } from 'sonner';
import breakPoints from 'helpers/Styles';
import { Link } from 'prismic-reactjs';

const Modal = ({ show, onClose }) => {
  if (!show) {
    return null;
  }

  const emailTo = 'support@aftershockpc.com.au';

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [businessEmail, setBusinessEmail] = useState('');
  const [businessNumber, setBusinessNumber] = useState('');
  const [orgainsation, setOrgainsation] = useState('');
  const [industry, setIndustry] = useState('');
  const [addition, setAddition] = useState('');
  const [details, setDetails] = useState('');
  const [sending, setSending] = useState(false);
  const form = useRef();
  const sendEmail = (e) => {
    setSending(true);
    e.preventDefault();

    emailjs
      .sendForm(
        'service_z51h2hk',
        'template_b0xckqg',
        form.current,
        'EHLLCbLlIfGaD7hiA',
      )
      .then(
        (result) => {
          setFirstName('');
          setLastName('');
          setBusinessEmail('');
          setBusinessNumber('');
          setOrgainsation('');
          setIndustry('');
          setAddition('');
          setDetails('');
          setSending(false);
          toast.success('Successfully sent email!');
        },
        (error) => {
          toast.error('Something went wrong!');
          console.log(error.text);
          setSending(false);
        },
      );
  };

  return (
    <>
      <Toaster position="top-center" richColors />
      <div className="modalOverlay" onClick={onClose}>
        <div className="modalContent" onClick={(e) => e.stopPropagation()}>
          <button className="closeButton" onClick={onClose}>
            ×
          </button>
          <div className="form-title">
            Contact us for additional information on Aftershock Custom Servers
          </div>
          <form className="form" ref={form} onSubmit={sendEmail}>
            <input
              className="input"
              type="text"
              hidden
              name="details"
              value={details}
            />
            <input
              className="input"
              type="text"
              hidden
              name="email_to"
              value={emailTo}
            />
            <input
              className="input"
              type="text"
              hidden
              name="region"
              value={'AU'}
            />
            <div className="formGroup">
              <input
                required
                className="form-input"
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <input
                required
                className="form-input"
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
            <div className="formGroup">
              <input
                required
                className="form-input"
                type="email"
                placeholder="Business Email Address"
                value={businessEmail}
                onChange={(e) => setBusinessEmail(e.target.value)}
              />
              <input
                required
                className="form-input"
                type="tel"
                placeholder="Business Phone Number"
                value={businessNumber}
                onChange={(e) => {
                  setBusinessNumber(e.target.value);
                  setDetails(`<b>Contact Number:</b> ${businessNumber}`);
                }}
              />
            </div>
            <div className="formGroup">
              <input
                required
                className="form-input"
                type="text"
                placeholder="Organisation/University"
                value={orgainsation}
                onChange={(e) => setOrgainsation(e.target.value)}
              />
              <input
                required
                className="form-input"
                type="text"
                placeholder="Industry"
                value={industry}
                onChange={(e) => setIndustry(e.target.value)}
              />
            </div>
            <div className="formGroup">
              <textarea
                className="form-text-area"
                placeholder="Additional Detail"
                value={addition}
                onChange={(e) => setAddition(e.target.value)}
              ></textarea>
            </div>
            <div className="submit_area">
              <a
                href="/pages/privacy"
                className="privacyPolicy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <button type="submit" className="submitButton">
                {sending ? (
                  <>
                    {`Sending`}
                    <span className="loader" />
                  </>
                ) : (
                  'Submit'
                )}
              </button>
            </div>
          </form>
        </div>
        <style jsx global>{`
          @font-face {
            font-family: 'EuroStyleNormal';
            src: url('/fonts/EuroStyleNormal.woff') format('woff');
            font-weight: normal;
          }
          .modalOverlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
          .form-title {
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 40px;
            line-height: 44px;
            margin-bottom: 20px;
          }
          .form-input {
            font-family: "EuroStyleNormal";
            letter-spacing: 2px;
            width: 50%;
            height: 80px;
            padding: 12px;
            border-radius: 0;
            border: 2px solid transparent;
            background-color: #353535;
            font-size: 20px;
            outline: none;
            color: #ffffff;
            transition:
              border 0.2s ease,
              color 0.2s ease;
          }
          .form-input:hover {
            border: 2px solid #a41c1c;
          }
          .form-text-area {
            font-family: "EuroStyleNormal";
            letter-spacing: 2px;
            height: 80px;
            padding: 25px 12px;
            border-radius: 0;
            border: 2px solid transparent;
            background-color: #353535;
            font-size: 20px;
            outline: none;
            color: #ffffff;
            resize: none;
            transition:
              border 0.2s ease,
              color 0.2s ease;
          }
          .form-text-area:hover {
            border: 2px solid #a41c1c;
          }
          .modalContent {
            background: #272727;
            padding: 20px 81px 60px 81px;
            max-width: 1300px;
            width: 100%;
            position: relative;
            margin: 0 40px;
          }
          .form-input::placeholder {
            padding: 3px;
            color: #fff;
            transition:
              transform 0.2s ease,
              font-size 0.2s ease,
              color 0.2s ease;
          }
          .form-input:focus::placeholder {
            transform: translateY(-20px) translateX(-65px) scale(0.75);
            color: #a41c1c;
          }
          .form-input:focus {
            border: 2px solid #a41c1c;
          }
          .form-text-area::placeholder {
            color: #fff;
            transition:
              transform 0.2s ease,
              font-size 0.2s ease,
              color 0.2s ease;
          }
          .form-text-area:focus::placeholder {
            transform: translateY(-20px) translateX(-135px) scale(0.75);
            color: #a41c1c;
          }
          .form-text-area:focus {
            border: 2px solid #a41c1c;
          }
          .closeButton {
            position: absolute;
            width: 30px;
            height: 30px;
            top: -12px;
            right: -15px;
            border: none;
            font-size: 24px;
            color: #fff;
            cursor: pointer;
            background-color: #5a5a5a;
            border-radius: 100%;
          }
          .form {
            display: flex;
            flex-direction: column;
          }
          .formGroup {
            display: flex;
            gap: 30px;
            margin-bottom: 30px;
          }
          input,
          textarea {
            width: 100%;
            padding: 10px;
            border-radius: 4px;
            border: 1px solid #ccc;
          }
          .submit_area {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
          }
          .privacyPolicy {
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 28px;
            line-height: 31px;
            text-decoration-line: underline;
            color: #ffffff;
          }
          .submitButton {
            background-color: #a41c1c;
            border: none;
            padding: 15px 30px;
            border-radius: 4px;
            cursor: pointer;
            font-family: 'Eurostile-Bold';
            font-weight: 400;
            font-size: 28px;
            line-height: 31px;
            color: #ffffff;
            text-transform: none;
          }
          @media (max-width: ${breakPoints.medium}) {
            .modalContent {
              max-width 600xp;
              margin: 0 20px;
              padding: 20px 20px;
            }
            .form-input:focus::placeholder {
              transform: translateY(-20px);
            }
            .form-text-area:focus::placeholder {
              transform: translateY(-20px);
            }
            .form-title {
              font-size: 20px;
              line-height: 20px;
            }
            .formGroup {
              margin-bottom: 10px;
              gap: 10px;
            }
            .form-input {
              font-size: 15px;
              line-height: 15px;
              height: 70px;
            }
            .form-text-area {
              font-size: 15px;
              line-height: 30px;
            }
            .privacyPolicy {
              font-size: 20px;
              line-height: 20px;
            }
            .submitButton {
              font-size: 20px;
              line-height: 20px;
            }
          }
        `}</style>
      </div>
    </>
  );
};

export default Modal;
